import * as React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { useMemberTasks, useTasks } from "@nju/data-access-portal-service";
import { portalRoutes } from "@nju/routes";
import { A, Box, Button, Panel, Separator, Text } from "@nju/ui";
import { CancellationError } from "./CancellationError";
import { CancellationInProgress } from "./CancellationInProgress";
import { CancellationNotPossible } from "./CancellationNotPossible";
import { cancelPortoutMachine } from "./partials";

export function CancelPortoutPage() {
  const router = useRouter();
  const parentTasks = useTasks();
  const memberTasks = useMemberTasks();
  const { mnpPortout } = memberTasks || parentTasks;
  const params = portalRoutes.mojeKonto.anulujPrzeniesienie.index
    .input(router.query)
    .unwrap();

  const [current, send] = useMachine(cancelPortoutMachine, {
    context: {
      userId: mnpPortout?.userId,
      taskId: mnpPortout?.id,
    },
  });
  const { matches } = current;

  const cancelPortout = React.useCallback(() => {
    send({ type: "CANCEL_PORTOUT" });
  }, [send]);

  if (matches("success")) {
    return <CancellationInProgress userId={params?.userId} />;
  }

  if (matches("error")) {
    return <CancellationError />;
  }

  if (matches("expired")) {
    return <CancellationNotPossible />;
  }

  return (
    <Panel>
      <Text
        size={{
          "@onlyMobile": "xl",
          "@fromTablet": "keyM",
        }}
        weight="bold"
      >
        anulujesz przeniesienie numeru i zostajesz w nju subskrypcja?
      </Text>
      <Separator size="l" />
      <Text
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "l",
        }}
      >
        Twoja prośba o przeniesienie numeru zostanie anulowana, a Twoja usługa
        pozostanie aktywna.
      </Text>
      <Separator size="s" tone="invisible" />
      <Box
        display="flex"
        flexDirection={{
          "@onlyMobile": "columnReverse",
        }}
        justify={{
          "@fromTablet": "spaceBetween",
        }}
      >
        <Link
          href={portalRoutes.mojeKonto.index.get({
            mode: "mobile",
            ...(params?.userId && { userId: params.userId }),
          })}
          passHref={true}
        >
          <A
            className="only-mobile:mt-3"
            size={{
              "@onlyMobile": "s",
            }}
            variant="secondary"
          >
            nie, przenieś numer
          </A>
        </Link>
        <Button
          isLoading={matches("cancelPortout")}
          onPress={cancelPortout}
          size={{
            "@onlyMobile": "s",
          }}
        >
          tak, anuluj przeniesienie
        </Button>
      </Box>
    </Panel>
  );
}
